export const whatDoWeDo = {
	title: 'What do we do',
	ourProjects: 'Our projects',
	items: [
		[
			{text: 'Artificial lighting', image: '/img/public/whatDoWeDo/icons/umeleOsvetlenie.svg'},
			{text: 'Public lighting', image: '/img/public/whatDoWeDo/icons/verejneOsvetlenie.svg'},
			{text: 'Electrical installations', image: '/img/public/whatDoWeDo/icons/elektrickeInstalacie.svg'},
			{text: 'Substations', image: '/img/public/whatDoWeDo/icons/trafostanice.svg'},
		],
		[
			{text: 'Line constructions - NN, VN', image: '/img/public/whatDoWeDo/icons/linioveStavby.svg'},
			{text: 'Structured cabling', image: '/img/public/whatDoWeDo/icons/strukturovaneKabelaze.svg'},
			{text: 'Optical networks', image: '/img/public/whatDoWeDo/icons/optickeSiete.svg'},
			{text: 'ESS', image: '/img/public/whatDoWeDo/icons/ezs.svg'},
		],
		[
			{text: 'Revisions, grid analysis', image: '/img/public/whatDoWeDo/icons/opaos.svg'},
			{text: 'CCTV', image: '/img/public/whatDoWeDo/icons/cctv.svg'},
			{text: 'FAS', image: '/img/public/whatDoWeDo/icons/eps.svg'},
			{text: 'FAVES', image: '/img/public/whatDoWeDo/icons/hsp.svg'},
		],
	],
};
